import { useState } from "react";
import { Button, Icon, Radio, RadioList, Switch, Text } from "@ucl/react-library";
import {
  getSettingsFromStorage,
  setCustomerServiceMockEnabledToStorage,
  setDocumentServiceMockEnabledToStorage,
  setMockOutcomeToStorage,
  setMocksEnabledToStorage,
  setSlowModeToStorage,
} from "src/mocks/settings/storage-interface";

export const DevTools = () => {

  const [showDevTools, setShowDevTools] = useState<boolean>(false);
  const {
    mocksEnabled: initialMocksEnabled,
    slowMode: initialSlowMode,
    customerServiceMockEnabled: initialCustomerServiceMockEnabled,
    documentServiceMockEnabled: initialDocumentServiceMockEnabled,
    mocksOutcome: initialMocksOutcome
  } = getSettingsFromStorage();

  const [mocksEnabled, setMocksEnabled] = useState<boolean>(initialMocksEnabled);
  const [slowMode, setSlowMode] = useState<boolean>(initialSlowMode);
  const [customerServiceMockEnabled, setCustomerServiceMockEnabled] = useState<boolean>(initialCustomerServiceMockEnabled);
  const [documentServiceMockEnabled, setDocumentServiceMockEnabled] = useState<boolean>(initialDocumentServiceMockEnabled);
  const [mockOutcome, setMockOutcome] = useState<string>(initialMocksOutcome);

  const handleCustomerServiceMockToggle = (evt: any) => {
    setCustomerServiceMockEnabledToStorage(evt.target.checked);
    setCustomerServiceMockEnabled(evt.target.checked);
  };

  const handleDocumentServiceMockToggle = (evt: any) => {
    setDocumentServiceMockEnabledToStorage(evt.target.checked);
    setDocumentServiceMockEnabled(evt.target.checked);
  };

  const handleMockToggle = (evt: any) => {
    setMocksEnabledToStorage(evt.target.checked);
    setMocksEnabled(evt.target.checked);
  };

  const handleMockOutcomeToggle = (newValue: any) => {
    setMockOutcomeToStorage(newValue);
    setMockOutcome(newValue);
  };

  const handleSlowMode = (evt: any) => {
    setSlowModeToStorage(evt.target.checked);
    setSlowMode(evt.target.checked);
  };

  if (import.meta.env.VITE_MOCKS_ENABLED === "true") {
    return (
      <div className="fixed bottom-4 right-4 z-50 w-xs p-3.5">
        {!showDevTools && (
          <Button color="success" onClick={() => setShowDevTools(!showDevTools)} size="large">
            <p>{"</>"}</p>
          </Button>
        )}
        {showDevTools && (
          <div className="bg-white p-6 rounded shadow-lg">
            <div className="flex justify-between items-center mb-5">
              <Text renderAs={"h2"} styleType={"h4"}>
                Dev Tools
              </Text>
              <Button onClick={() => setShowDevTools(!showDevTools)} size="small" variant={"secondary"}>
                <Icon icon="close" />
              </Button>
            </div>
            <div className="flex gap-3.5 items-center mb-6">
              <Switch size="medium" aria-label="notification" onChange={handleMockToggle} checked={mocksEnabled} />
              <Text.P size={"large"}>Enable mocking</Text.P>
            </div>

            <div className="flex gap-3.5 items-center mb-6">
              <Switch
                size="medium"
                aria-label="notification"
                onChange={handleCustomerServiceMockToggle}
                checked={mocksEnabled && customerServiceMockEnabled}
                disabled={!mocksEnabled}
              />
              <Text.P size={"large"}>Mock at Customer Service</Text.P>
            </div>

            <div className="flex gap-3.5 items-center mb-6">
              <Switch
                size="medium"
                aria-label="document-service-mock"
                onChange={handleDocumentServiceMockToggle}
                checked={mocksEnabled && documentServiceMockEnabled}
                disabled={!mocksEnabled}
              />
              <Text.P size="large">Enable mock for Document Service</Text.P>
            </div>

            <div className="flex gap-3.5 items-center mb-6">
              <Switch
                size="medium"
                aria-label="slow-mode"
                onChange={handleSlowMode}
                checked={slowMode}
                disabled={!mocksEnabled}
              />
              <Text.P size="large">Enable slow mode</Text.P>
            </div>

            <div className="flex gap-3.5 items-center mb-6">
              <RadioList
                labelProps={{ labelProp: { label: "Mock outcome" } }}
                size="small"
                disabled={!mocksEnabled}
                onChange={handleMockOutcomeToggle}
                value={mockOutcome}
              >
                <Radio label="Success" value="success" name="outcome" />
                <Radio label="Bad request" value="badRequest" name="outcome" />
                <Radio label="Unauthorised" value="unauthorised" name="outcome" />
                <Radio label="Internal server error" value="internalServer" name="outcome" />
                <Radio label="Not found" value="notFoundCustomer" name="outcome" />
              </RadioList>
            </div>
          </div>
        )}
      </div>
    );
  } else {
    return null;
  }
};

export default DevTools;
